import { render, staticRenderFns } from "./ClaimTextDisplay.vue?vue&type=template&id=21ce1b26&scoped=true&"
import script from "./ClaimTextDisplay.vue?vue&type=script&lang=ts&"
export * from "./ClaimTextDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./ClaimTextDisplay.vue?vue&type=style&index=0&id=21ce1b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce1b26",
  null
  
)

export default component.exports